import { createI18n } from "vue-i18n";
import { zh } from "./locale/zh";
import { en } from "./locale/en";
import { ph } from "./locale/ph";
import { getI18nList } from "@/api/common";
import router from "@/router";

type AppLocale = "pt" | "zh" | "en";

const messages = {
  pt: { ...ph },
  zh: { ...zh },
  en: { ...en },
};

const langLoaded = false;

const i18n = createI18n({
  locale: "pt",
  fallbackLocale: "pt",
  messages,
});

const resolveLocale = (lang: string): AppLocale =>
  lang in messages ? (lang as AppLocale) : "pt";

const loadLanguage = async (lang: string) => {
  getI18nList(lang).then(res => {
    i18n.global.setLocaleMessage(lang, res.data);
    i18n.global.locale = resolveLocale(lang);
    localStorage.setItem("lang", lang);
  }).catch(() => {
    const fallbackLang = resolveLocale(lang);
    i18n.global.setLocaleMessage(fallbackLang, messages[fallbackLang]);
    i18n.global.locale = fallbackLang;
    localStorage.setItem("lang", fallbackLang);
  })
};

const init = async () => {
  setTimeout(async () => {
    const currentRoute = router.currentRoute.value;
    if (currentRoute.query.lan) {
      localStorage.setItem("lang", String(currentRoute.query.lan));
    } else {
      localStorage.setItem("lang", 'pt');
    }

    const lang = localStorage.getItem("lang") || 'pt';
    await loadLanguage(lang);
  }, 1000)
}

export { i18n, langLoaded, loadLanguage, init };
